import 'bootstrap/dist/css/bootstrap.min.css';
// import $ from 'jquery';
// import Popper from 'popper.js';
import 'antd/dist/antd.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';
import App from './App';
import DownloadPopup from './components/DownloadPopup';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './styles/general.scss';
import './styles/index.scss';

import { SiteProvider } from './context/SiteContext';

ReactDOM.render(
  <RecoilRoot>
    <SiteProvider>
      <App />
      <DownloadPopup />
    </SiteProvider>
  </RecoilRoot>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
